var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Table',{attrs:{"page-footer":true,"search-url":_vm.url,"isAssess":false,"operationLeft":false,"back":{},"tableTitle":_vm.tableTitle,"operation-list":_vm.operationList},on:{"operation-click":_vm.operationClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }